<div class="custella-modal">
     <div class="custella-modal-header align-items-center">
        <div class="custella-modal-header-text">Learn More</div>
        <i class="pi pi-times" [pTooltip]="translate?.general?.buttons?.close.singular" tooltipPosition="left"  (click)="modalRef.hide()"></i>
    </div>
    <div class="open-modal">
        <app-intro-page
        [data]="introPageData"
        [isModalView]="true"
        [moduleKey]="selectedModuleKey">
        </app-intro-page>

    </div>
</div>